import ComponentElement from 'components/component-element';
import Swiper from 'vendor_components/swiper.min';

function WeatherBlock($element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.$element.querySelectorAll('.swiper').forEach($swiper => {
        new Swiper($swiper, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            speed: 300,
        });
    });
}

WeatherBlock.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(WeatherBlock.prototype, 'constructor', {
    value: WeatherBlock,
    writable: true,
    enumerable: false,
});

export default WeatherBlock;
